import React from 'react';
import { RouteFormatter } from '../routes';

const WATER_FAQS_CONTENT = [
    {
        que: 'Are dog water parks and swimming pools safe?',
        ans: () => (
            <>
                Public dog water parks and swimming pools are often crowded and can prevent dogs from interacting naturally. Thankfully, this isn't a
                concern with Sniffspot's private dog park rentals! Having your own space for recreational swimming is much safer than visiting public
                dog parks — you won't have to share with other park patrons. With Sniffspot all bookings are private for just you and dogs you bring
                with you, and we require all dogs to be vaccinated (or have equivalent titers). All Sniffspot locations are vetted and reviewed by
                guests so you can find the perfect place for you and your dog. For our indoor and outdoor water parks, this means hosts are rated on
                things like communication, clean water, and other amenities. 93% of reviews on Sniffspot visits are 5 stars.
                <br />
                <br />
                If you're worried about your dog around the water itself, you can keep safety your top priority when visiting a water park with your
                furry friend by: Knowing water safety guidelines, always supervising dogs during water activities, learning canine CPR, making sure
                you know the signs of heatstroke or overexertion, investing in a doggie life jacket, and considering private swimming lessons or
                individual swim sessions at a canine swimming facility first if you're worried about how your pup will handle their swim time in a
                dedicated water park area or heated pool.{' '}
                <a href={RouteFormatter.helpCenter.waterSafe()} target="_blank" rel="noreferrer">
                    You can learn more about canine swimming safety here!
                </a>
            </>
        ),
    },
    {
        que: 'What are the benefits of visiting a water park or swimming pool with my dog?',
        ans: () => (
            <>
                The hot summer months are no joke in many parts of the United States. Some traditional dog parks — especially those with asphalt or
                gravel surfaces — can become sweltering at midday, making it unsafe for your dog to run around without hurting their paws or even
                being at risk of heatstroke. Canine water parks don't have this problem since your pup can be in and out of the cool water for a
                refreshing swim as they please! That makes for a fun-filled day, even more so if there are extra doggy water elements to enjoy like
                floating toys, slides, and docks.
                <br />
                <br />
                Plus most dog water parks, whether outdoor pools or indoor water facilities, are enclosed to keep your furry friend from running off.
                Fenced off-leash dog parks parks provide your pet with an opportunity to stretch their legs without causing you any worry that they'll
                escape or get in harm's way.
            </>
        ),
    },
    {
        que: 'Do all dogs know how to swim?',
        ans: () => (
            <>
                Believe it or not, not every dog is born knowing exactly how to swim. Many first-time swimmers have to be taught how to stay calm when
                their feet leave the ground and to paddle rhythmically — and it is possible for dogs to get hurt, even just during casual recreational
                swimming, if they aren't well prepared.
                <br />
                <br />
                Doggy life jackets can be a potential solution to this, giving nervous dogs more confidence and pet parents peace of mind. So can lots
                of breaks during swim time to let your pup rest. Take water activities slowly as your furry friend builds confidence in their swimming
                abilities. After a couple of swims, most pets get the hang of things quickly!
            </>
        ),
    },
    {
        que: 'How can I find amazing dog water parks and indoor pools near me?',
        ans: () => (
            <>
                You can browse all of our dog water parks above, at the top of this page. Sniffspot has options for first-time swimmers and
                experienced water fanatics!
            </>
        ),
    },
    {
        que: 'How do I know if a dog water park works for my dog?',
        ans: () => (
            <>
                Looking for specific amenities? Start by applying basic filters to sort Sniffspots by fencing and distractions to find a listing that
                works for your dog. If your furry friend doesn't have a good recall, you can visit one of our fully fenced dog water parks. If your
                dog is reactive to other dogs, you can visit one of our designated water parks where there are no dogs audible or visible nearby. You
                can also check for features like provided water toys, drinking fountains, self-wash or bathing stations, dock diving supplies, and
                more to create the most enjoyable water experience possible.
                <br />
                <br />
                Want to search by location? Browse on our map by Sniffspot location to find a fun park near your city to make travel convenient.
                <br />
                <br />
                We recommend reading reviews and reaching out to the host ahead of time with any questions! You can get all the details you need to
                know, like if the Sniffspot private rental has a heated swimming pool, how many feet deep the water is, what the available swim hours
                are, and any other dog park policy information.
            </>
        ),
    },
    {
        que: 'What are the requirements to bring my dog to a Sniffspot water park?',
        ans: () => (
            <>
                We require that all dogs have basic vaccinations or equivalent titers before recreational swimming. It's always a good idea to keep
                your pet's vaccination records up to date. We do not permit private dog park use by pregnant dogs or pets with a bite history — and we
                require that pet parent guests sign our waiver and agree to follow our safety rules before bringing their furry friend to a Sniffspot
                dog park, such as staying within the designated off-leash area. Additionally, we recommend following our water safety guidelines
                during any private swims with your pup.
                <br />
                <br />
                Each park location also has their own set of rules that guests need to follow, such as limiting excessive barking and otherwise
                ensuring respectful canine behavior.
            </>
        ),
    },
    {
        que: 'Will there be other dogs at the Sniffspot water park at the same time as me?',
        ans: () => (
            <>
                No, there will not be any other park patrons. Your rental is private, <i>not</i> a public dog park! You will have your reserved
                Sniffspot all to yourself: a safe environment just for you and your furry friend to enjoy.
                <br />
                <br />
                Sniffspot only allows one booking at a time. Any host dogs are required to be kept away from the spot during visits. We also enforce
                30 minute time buffers between bookings to make sure you don't run into any surprises.
            </>
        ),
    },
    {
        que: 'How much do Sniffspot dog water parks cost?',
        ans: () => (
            <>
                Each host sets their own price, so you can check the price on the specific Sniffspot dog park listing. Most are between $5 - $15 per
                dog per hour depending on amenities. Extra services, like lessons during your pup's swim sessions, can be charged separately.
            </>
        ),
    },
    {
        que: 'Can I have an event or party at a dog water park?',
        ans: () => (
            <>
                If you are planning an amazing off-leash dog park party, know that each Sniffspot water park and swimming pool has their own rules
                regarding special events. Many water parks allow recreational swimming during doggie birthday parties, training, and other activities!
                Check with the host of the listing you're interested in for more information, rules, and additional fees. Event organizers need to be
                responsible for all their guests.
            </>
        ),
    },
    {
        que: 'What are the coolest doggie water features available?',
        ans: () => (
            <>
                Sniffspot dog water parks can have a variety of features: everything from swimming pools (including salt water pools, heated pools,
                both outdoor pools and indoor swim options, and more) to rivers to beaches to hoses to kiddie pools and more. Some listings have extra
                special amenities like ball pit pools, water tunnels, water slides, splash pads, and customizable water activities!
                <br />
                <br />
                Every water park is different, so check the details of each Sniffspot listing to find the perfect one for you and your pup. If they're
                a first-time swimmer, for example, you might reach out to hosts about private lessons alongside recreational swimming opportunities or
                look for a shallower depth pool.
            </>
        ),
    },
];

const HIKING_FAQS_CONTENT = [
    {
        que: 'Are dog hiking trails safe?',
        ans: () => (
            <>
                The answer to this question depends greatly on the specific rules and culture of each individual dog-friendly hiking trail. On crowded
                popular trails where off-leash dogs regularly greet one another, it can be difficult to ensure all interactions are positive.
                Uncertain dogs are easily overwhelmed by quick approaches from strangers — if the dog-friendly trail is narrow without adequate space
                to flee, these canine companions can quickly feel trapped or resort to the “fight” option of fight-or-flight reactions. After a few
                stressful experiences, previously shy dogs can lose trust in their owners and even become fear aggressive.
                <br />
                <br />
                Sniffspot takes these risks seriously. That's why all of our private dog park listings, including hiking trail systems, are carefully
                booked to make sure there's ample time between arrivals and departures — and you can filter listings by whether or not your dog is
                likely to see any other animals at all, even from afar! Plus all Sniffspot locations are vetted and reviewed by guests so you can find
                the perfect place for you and your dog based on firsthand experiences from fellow nature lovers. 93% of reviews on Sniffspot visits
                are 5 stars. And our hiking trails tend to be outside the city, which lends to more privacy on your trail adventures. (Note that it is
                still important to follow typical hiking safety precautions, such as potentially having trail maps downloaded ahead of time.)
            </>
        ),
    },
    {
        que: 'How can I find dog hiking trails near me?',
        ans: () => (
            <>
                You can browse all of our dog hiking trails above, at the top of this page. View them on a map to find a quick escape or apply filters
                if you're looking for something specific!
            </>
        ),
    },
    {
        que: 'How do I know if a dog hiking trail works for my dog?',
        ans: () => (
            <>
                Sniffspot provides tools to find the ideal dog-friendly trails for you and your furry friend. Start by applying basic filters like
                whether a spot has fencing or if certain distractions (like other dogs, wildlife, or loud noises) are present. If your dog doesn't
                have a good recall yet? You can visit one of our fully fenced dog hiking trails or opt for a less expansive off-leash dog park. If
                your dog is reactive to other dogs? You can visit one of our dog hiking trails where there are no dogs audible or visible nearby.
                <br />
                <br />
                You can also filter by size if you are looking for a certain number of miles of trails or have a minimum acre park in mind.
                <br />
                <br />
                We provide resources to check elevation and hike intensity, too! Make sure to check photos to see if the spot has flat trails or
                gnarly trails. You can also browse by specific amenities, if you are looking for a view or a beach, for instance, or other activities
                or fun features. You can check whether the spot has off or on street parking, the regular park hours, whether it has paved trails or a
                modern restroom.
            </>
        ),
    },
    {
        que: 'What are the requirements to bring my dog to a Sniffspot dog hiking trail?',
        ans: () => (
            <>
                To hike a Sniffspot trail, we require that all dogs have basic vaccinations or equivalent titers. It's a good idea to keep your pet's
                vaccination records up to date. We do not permit private dog park use by pregnant dogs or pets with a bite history — and we require
                that pet parent guests sign our waiver and agree to follow our safety rules before bringing their furry friend to a Sniffspot dog park
                or dog-walking trail, such as staying within the designated off-leash area.
                <br />
                <br />
                Each park location also has their own set of rules that guests need to follow, such as limiting excessive barking and otherwise
                ensuring respectful canine behavior.
            </>
        ),
    },
    {
        que: 'Will there be other dogs at the Sniffspot hiking trail at the same time as me?',
        ans: () => (
            <>
                No, there will not. Your rental is private, <i>not</i> a public dog park! You will have your reserved Sniffspot all to yourself: a
                safe environment just for you and your furry friend to enjoy.
                <br />
                <br />
                Sniffspot only allows one booking at a time. Any host dogs are required to be kept away from the spot during visits. We also enforce
                30 minute time buffers between bookings to make sure you don't run into any surprises.
            </>
        ),
    },
    {
        que: 'How much do Sniffspot hiking trails cost?',
        ans: () => (
            <>
                Each host sets their own price, so you can check the price on the specific Sniffspot dog park listing. Most are between $5 - $15 per
                dog per hour for a popular dog park hiking trail, depending on terrain and amenities.
            </>
        ),
    },
];

const FENCED_FAQS_CONTENT = [
    {
        que: 'Are fully fenced dog parks safe?',
        ans: () => (
            <>
                While fences are great for keeping your dog from running off, they also have their drawbacks in public dog parks.
                <br />
                <br />
                For one thing, most fenced-in dog parks are relatively small in size due to the financial and labor costs of erecting long fences.
                This can lead to issues with dogs expressing natural canine body language, especially if the fenced-in area is crowded — some pups
                might feel physically cornered with no way to escape an interaction they don't want, which can lead to a “fight” response when
                “flight” isn't an option.
                <br />
                <br />
                For another, public dog parks can be riddled with diseases. There's no way to guarantee that every guest has had proper vaccinations
                if you're using a popular off-leash area, and it can be hard for city staff to keep park areas clean.
                <br />
                <br />
                That's why we generally do not recommend taking your dog to public dog parks with other people and pets you don't know. And it's why
                we've created our private dog park listings to make off-leash fun safer for you and your furry friend!
                <br />
                <br />
                Sniffspot dog parks are much safer than a public off-leash dog park. (They're also more reliable than trying to run your dog on a foot
                ball field, baseball field, tennis court, or other unregulated public spot where you might not know what to expect... or where dogs
                might not be allowed in the first place.)
                <br />
                <br />
                All Sniffspot bookings are private for just you and dogs you bring with you! We also require all dogs to be vaccinated or have
                equivalent titers. Every Sniffspot location is vetted and reviewed by guests, so you can find the perfect place for you and your dog.
                93% of reviews on Sniffspot visits are 5 stars.
            </>
        ),
    },
    {
        que: 'How can I find fully fenced dog parks near me?',
        ans: () => (
            <>
                You can browse all of our fenced-in dog park options by using the park locator at the top of this page. We also provide detailed
                filters so you can sort through listings based on any specific criteria you have!
            </>
        ),
    },
    {
        que: 'How do I know if an enclosed park works for my dog?',
        ans: () => (
            <>
                Many people looking for fully fenced parks have dogs that are still learning how to come back when called. We've got you covered!
                <br />
                <br />
                Start by applying basic filters, such as fencing and distractions, to find a fenced-in space for dogs that works for your unique furry
                friend. You can see attributes of fences such as height, gaps, and type to find the perfect fenced-in area. If your dog is reactive to
                other dogs, you can visit one of our off-leash areas where there are no dogs audible or visible near the space.
                <br />
                <br />
                You can also filter each Sniffspot dog park by size — either to make sure you have plenty of space to play or to make sure your dog
                won't be able to get too far away from you if you're worried.
                <br />
                <br />
                Make sure to review the amenities of the spot to check features you want for your activity, such as water fountains, agility
                equipment, waste bags, shade structures, benches for people, or other special offers hosts might offer. If you prefer wood chips over
                grass or artificial turf, for example, many of our parks have different types of terrain. Some Sniffspots even offer separate indoor
                spaces to enjoy as well!
            </>
        ),
    },
    {
        que: 'What are the requirements to bring my dog to a Sniffspot fenced-in dog park?',
        ans: () => (
            <>
                To visit a fenced-in Sniffspot private dog park, we require that all dogs have basic vaccinations or equivalent titers. It's a good
                idea to keep your pet's vaccination records up to date. We do not permit private dog park use by pregnant dogs or pets with a bite
                history — and we require that pet parent guests sign our waiver and agree to follow our safety rules before bringing their furry
                friend to a Sniffspot dog park, such as staying within the designated off-leash area.
                <br />
                <br />
                Each park location also has their own set of rules that guests need to follow, such as limiting excessive barking, having a maximum
                number of dogs per owner, and otherwise ensuring respectful canine behavior.
            </>
        ),
    },
    {
        que: 'Will there be other dogs at the Sniffspot fenced dog park at the same time as me?',
        ans: () => (
            <>
                No, there will not. Your rental is private, <i>not</i> a public dog park! You will have your reserved Sniffspot all to yourself: a
                safe environment just for you and your furry friend to enjoy.
                <br />
                <br />
                Sniffspot only allows one booking at a time. Any host dogs are required to be kept away from the spot during visits. We also enforce
                30 minute time buffers between bookings to make sure you don't run into any surprises.
            </>
        ),
    },
    {
        que: 'How much do Sniffspot fully fenced dog parks cost?',
        ans: () => (
            <>
                Each park location sets their own price, so you can check the cost on the specific Sniffspot park location listing. Most are between
                $5 - $15 per dog per hour.
            </>
        ),
    },
];

const FIELDS_FAQS_CONTENT = [
    {
        que: 'Are dog fields safe?',
        ans: () => (
            <>
                If you are looking for an adventure but also looking for safety, Sniffspot's private dog fields are a great option!
                <br />
                <br />
                While public dog parks have a number of safety issues — like potentially aggressive dogs, distracted dog owners, disease transmission,
                general cleanliness, and an unnatural social environment — Sniffspot private dog parks are much safer. With Sniffspot all bookings are
                just you and doggy friends you bring with you, so you can say goodbye to the stress of visiting busy dog parks and wondering whether
                all the dogs off leash will have any negative interactions.
                <br />
                <br />
                We also require all dogs to be vaccinated (or have equivalent titers) to keep our park areas clean.
                <br />
                <br />
                And contrary to public dog parks, all Sniffspot private park locations are vetted and reviewed by guests — so you can find the perfect
                place for you and your dog for off leash exercise, training, or simply relaxing together. 93% of reviews on Sniffspot visits are 5
                stars, while public dog parks often do not even have verified reviews.
                <br />
                <br />
                All payment is done securely online by credit card in a few simple clicks.
            </>
        ),
    },
    {
        que: 'How can I find dog fields near me?',
        ans: () => (
            <>
                You can browse Sniffspot fields for rent by using the park locator at the top of this page. You can filter by distance from where you
                are, park size, amenities, and more.
            </>
        ),
    },
    {
        que: 'How do I know if a dog field works for my dog?',
        ans: () => (
            <>
                All park rental information is available online! This makes it easy for hosts to update quickly if anything changes and for pet owners
                like you to find the perfect fit for your unique dog.
                <br />
                <br />
                Start by filtering our private dog parks by fencing, size, and distractions to find a private spot that works for your pup's needs. If
                your dog has poor recall, you can visit one of our secure fields to enjoy being off leash in a safe environment. If your dog is
                reactive to other dogs, you can visit one of our dog fields where there are no dogs audible or visible nearby. If your dog is
                particularly small, hosts will note if there are any areas they might be able to escape from.
                <br />
                <br />
                Review the details of each listing to make sure it works as your desired activity space. Sniffspots are proud to provide opportunities
                for safe dog exercise, dog training sessions, stress-free adventures through green spaces, hikes on nature trails, and more. Check the
                park amenities chart for exciting features like an indoor training facility, an agility field, synthetic turf, exercise balls, or
                field parking availability in advance.
            </>
        ),
    },
    {
        que: 'What are the requirements to bring my dog to a Sniffspot dog field?',
        ans: () => (
            <>
                We require that all four-legged friends have basic vaccinations or equivalent titers. We do not allow pregnant dogs or dogs with a
                bite history. We require that guests sign our waiver and agree to follow our safety rules, like staying in the designated off-leash
                dog park property and properly disposing of waste to keep our parks clean.
                <br />
                <br />
                Make sure to check individual park host rules before visiting, too. Each private dog park location can specify their own restrictions
                to prevent park maintenance issues and keep everyone safe.
            </>
        ),
    },
    {
        que: 'Will there be other dogs at the Sniffspot field at the same time as me?',
        ans: () => (
            <>
                No. Facility rentals are for a private space and any host dogs are required to be kept away from the area during visits — they
                understand that many guests have dogs in training. This is perfect for a private adventure for just you and your canine companion!
                <br />
                <br />
                We also enforce 30 min time buffers between time slots so you will not run into other guest dogs or a previous person when coming or
                leaving in the field parking area. Some hosts may have multiple fields, but there is always a buffer between fields.
            </>
        ),
    },
    {
        que: 'How much do Sniffspot fields cost?',
        ans: () => (
            <>
                Each host sets their own price for facility and field rentals, so you can check the cost on the specific Sniffspot dog park listing.
                Most are between $5 - $15 per dog for time slots of one hour, but they vary by field size and amenities.
            </>
        ),
    },
];

const AGILITY_FAQS_CONTENT = [
    {
        que: 'Are dog agility parks safe?',
        ans: () => (
            <>
                Most agility courses have obstacles for your dog to jump over, climb on, and tunnel through. These activities can come with some risk
                just like any type of physical exercise — but as long as you supervise closely and take things at your dog's pace, they'll be just
                fine. Make sure you use the park dog agility equipment safely and start with basic skills training before trying anything more
                advanced.
                <br />
                <br />
                One of the best things about Sniffspot's private dog agility parks is that you'll have the whole off-leash area to yourself. Public
                dog parks sometimes include basic agility equipment, but they also come with a number of safety issues including potentially
                aggressive dogs, inattentive owners, disease transmission, and unnatural social interactions in a small, enclosed space — so a private
                space is a much safer option! Contrary to a typical dog park, with Sniffspot all bookings are for just you and dogs you bring with
                you. We require all dogs to be vaccinated (or have equivalent titers) to keep the space for dogs safe. And every Sniffspot location is
                vetted and reviewed by guests — so you can find the perfect place for you and your dog based on firsthand experiences from fellow pet
                parents! 93% of reviews on Sniffspot visits are 5 stars.
            </>
        ),
    },
    {
        que: 'How can I find dog agility courses near me?',
        ans: () => (
            <>
                You can browse all of our dog agility parks by using the park locator at the top of this page. Filter Sniffspot listings by location,
                size, amenities, and more!
            </>
        ),
    },
    {
        que: 'How do I know if a dog agility park works for my dog?',
        ans: () => (
            <>
                Our filter system is specifically designed to help pet parents find the perfect safe space to play with their dogs. You can start with
                basic filters like whether a spot is fenced or has many distractions visible (like other animals or loud noises). Most agility courses
                are similar in size, but some listings have more room to maneuver than others — you can sort by size if you have a preference.
                <br />
                <br />
                Once you've found a spot that looks good, read the detailed description to find out everything you need to know about the setup, such
                as whether there is a standard agility course or a basic home agility setup for your pup to use. You can swipe through photos to
                visualize where you'll spend your dog's time off leash. We recommend reading reviews and reaching out to the host with any questions!
            </>
        ),
    },
    {
        que: 'What are the requirements to bring my dog to a Sniffspot agility course?',
        ans: () => (
            <>
                We require that all dogs have basic vaccinations or equivalent titers. We do not allow pregnant dogs or dogs with a bite history. We
                require that guests sign our waiver and agree to follow our safety rules, like staying within the fenced dog agility park as specified
                and respecting time limits. Treat all park equipment with care!
            </>
        ),
    },
    {
        que: 'Will there be other dogs at the Sniffspot agility park at the same time as me?',
        ans: () => (
            <>
                No, there will not. Your rental is private, not a public county park! You will have your reserved Sniffspot all to yourself: a safe
                environment just for you and your furry friend to enjoy.
                <br />
                <br />
                Sniffspot only allows one booking at a time. Any host dogs are required to be kept away from the spot during visits. We also enforce
                30 minute time buffers between bookings to make sure you don't run into any surprises.
            </>
        ),
    },
    {
        que: 'How much do Sniffspot agility parks cost?',
        ans: () => (
            <>
                Each host sets their own price, so you can check the cost on the specific Sniffspot dog park agility listing. Most are between $5 -
                $15 per dog per hour, but expenses vary depending on property size and amenities.
            </>
        ),
    },
];

const SMALL_FAQS_CONTENT = [
    {
        que: 'Are small dog parks safe?',
        ans: () => (
            <>
                Public dog parks have a number of safety issues, especially for small dogs who are more susceptible to some diseases and can be easily
                hurt in the course of play. The top risks associated with public off-leash dog parks, especially for toy breeds, are that: dog parks
                can create an unnatural social environment where canines aren't able to express natural body language, all but the largest dog parks
                with space to move around can overwhelm shy or nervous dogs, busy dog parks can exacerbate problem behaviors like leash reactivity,
                bad experiences at a dog park can create behavior problems like fear aggression, and public dog parks can lead to physical injuries
                and illnesses from things like broken glass or discarded trash. In short: Public dog parks often aren't actually the safest
                environment for dogs.
                <br />
                <br />
                Thankfully, private dog parks don't have these concerns! All Sniffspot bookings are private for just you and the dogs you bring with
                you. We require all dogs to be vaccinated or have equivalent titers to keep every park clean. And each Sniffspot location is vetted
                and reviewed by park users — so you can find the perfect place for you and your dog based on firsthand accounts from pet parents just
                like you. 93% of reviews on Sniffspot visits are 5 stars.
            </>
        ),
    },
    {
        que: 'How can I find small dog parks near me?',
        ans: () => (
            <>
                You can browse all of our small dog parks by using the park locator at the top of this page. You can also filter by features and
                amenities! Many guests have found their all-time favorite dog parks by using our filtering system.
            </>
        ),
    },
    {
        que: 'How do I know if a small dog park works for my dog?',
        ans: () => (
            <>
                Choosing the right dog park environment can be tricky, especially if your pet is a toy breed who isn't always up to running with the
                big dogs.
                <br />
                <br />
                Start by applying basic filters to Sniffspot listings near you. Search for those that are fully fenced — and even confirm what type of
                fencing each park has to guarantee that your furry friend won't be able to escape! Hosts can mark their private dog parks as being
                designated small dog friendly. You can also filter by distractions present. If your dog is reactive to other dogs, for example, you
                can visit one of our small dog park sites where there are no animals audible or visible nearby. Don't forget to consider the park's
                size, too. Sniffspot has many different acre dog parks —the largest can contain miles of green spaces and dirt trails, while the
                smallest can create a cozy environment for you and your pup.
                <br />
                <br />
                Then have some more fun by searching for private dog park amenities. Many Sniffspot hosts go above and beyond with what they provide
                to guests and their dogs! Our private dog parks have been known to feature things like agility equipment, park benches, water
                fountains or other water stations, shaded seating, poop bags, kiddie pools, separate entrances, hiking trails, artificial turf, and
                more. If you can dream it, you can find it in a Sniffspot somewhere.
                <br />
                <br />
                We recommend reading reviews and reaching out to the host ahead of time with any questions! And note that each listing will have their
                available hours posted. Many of our private dog parks are open from dawn until dusk.
            </>
        ),
    },
    {
        que: 'What are the requirements to bring my dog to a Sniffspot park?',
        ans: () => (
            <>
                To visit a fenced-in Sniffspot private dog park, we require that all dogs have basic vaccinations or equivalent titers. This is
                especially important in off-leash areas with shared water fountains and toys. It's a good idea to keep your pet's vaccination records
                up to date.
                <br />
                <br />
                We do not permit private dog park use by pregnant dogs or dogs with a bite history. We also require that all pet parent guests sign
                our waiver ahead of time and agree to follow our safety rules before bringing their furry friend to any Sniffspot dog park. These are
                pretty simple guidelines like staying within the designated off-leash area (you can check park size ahead of time to make sure you
                have plenty of space!) and being respectful of property.
                <br />
                <br />
                Each park location also has their own set of rules that guests need to follow, such as limiting excessive barking or having a maximum
                number of dogs per owner.
            </>
        ),
    },
    {
        que: 'Will there be other dogs at the Sniffspot park at the same time as me?',
        ans: () => (
            <>
                No, there will not. Your rental is private, <i>not</i> a public dog park! You will have your reserved Sniffspot all to yourself: a
                safe environment just for you and your furry friend to enjoy.
                <br />
                <br />
                Sniffspot only allows one booking at a time. Any host dogs are required to be kept away from the spot during visits. We also enforce
                30 minute time buffers between bookings to make sure you don't run into any surprises.
            </>
        ),
    },
    {
        que: 'How much do Sniffspot small dog parks cost?',
        ans: () => (
            <>
                Each host sets their own price, so you can check the cost on the specific Sniffspot dog park listing. Most small dog parks are between
                $5 - $15 per dog per hour depending on size and amenities.
            </>
        ),
    },
    {
        que: 'Can I have an event or party at a small dog park?',
        ans: () => (
            <>
                If you want to give your furry friend the party of a lifetime, a Sniffspot private dog park could be the perfect place! Each Sniffspot
                listing has their own rules regarding special events. Many hosts allow activities ranging from doggie birthday parties to training
                sessions to swimming pool parties and other events.
                <br />
                <br />
                Event organizers need to be responsible for their guests and should coordinate with the host regarding their party. Make sure the
                private dog park has amenities you need for your party, like ample parking, trash cans, and plenty of shade.
            </>
        ),
    },
];

const BEACH_FAQS_CONTENT = [
    {
        que: 'Are dog beaches safe?',
        ans: () => (
            <>
                Public dog beaches can have a number of safety issues like potentially aggressive dogs, disease transmission, and general cleanliness.
                These risks are increased in off-leash dog parks, especially if park users don't have good voice control of their canine companions,
                bring dogs in heat onto the dog-friendly beach, or aren't required to have their pets vaccinated before visiting.
                <br />
                <br />
                Thankfully, these concerns don't apply to private dog parks! Sniffspot private dog beach rentals are much safer than a public
                off-leash park. With Sniffspot all bookings are just you and dogs you bring with you. We require all dogs to be vaccinated or have
                equivalent titers to keep each dog beach clean. And every Sniffspot location is vetted and reviewed by guests — so you can find the
                perfect place for you and your dog based on firsthand accounts from fellow pet owners. 93% of reviews on Sniffspot visits are 5 stars!
                <br />
                <br />
                If you're worried about your dog around the water itself at a beach park, you can keep safety your top priority when visiting with
                your furry friend by: Knowing water safety guidelines, always supervising dogs during water activities, learning canine CPR, making
                sure you know the signs of heatstroke or overexertion, looking for a location with plenty of shade, and considering private swimming
                lessons or individual swim sessions at a canine swimming facility first if you're worried about how your pup will do in a dedicated
                water park area.{' '}
                <a href={RouteFormatter.helpCenter.waterSafe()} target="_blank" rel="noreferrer">
                    You can learn more about canine swimming safety here!
                </a>
            </>
        ),
    },
    {
        que: 'Are dogs born knowing how to swim?',
        ans: () => (
            <>
                While dogs are often thought of as natural swimmers, they are not necessarily born with the ability to swim. Like humans, some dogs
                may be more naturally inclined to swim due to their breed or genetics — but most dogs need to become more comfortable in the water
                through exposure and training.
                <br />
                <br />
                It is important to introduce your dog to water slowly and safely. It is also important to never leave your dog unattended around
                bodies of water. Even strong swimmers can tire quickly or get into trouble without warning.
            </>
        ),
    },
    {
        que: 'How can I find dog beaches near me?',
        ans: () => (
            <>
                You can browse all of our dog beaches at the top of this page by using the park locator. You can also filter results by size, fencing,
                amenities, and more!
            </>
        ),
    },
    {
        que: 'How do I know if a dog beach works for my dog?',
        ans: () => (
            <>
                Start by applying basic filters, such as fencing and distractions, to find a Sniffspot that seems like a good fit for your dog. If
                your dog is reactive to other dogs, for example, you can visit one of our dog beaches where there are no dogs audible or visible
                nearby. If you're still working on your pup's recall, you can look for a beach that's fenced in or on the smaller side.
                <br />
                <br />
                Make sure to review the amenities of the spot, too, to see what kind of water features and other extras are offered. Some Sniffspot
                beaches offer everything from water fountains to wash stations to waste bags to adjacent nature trails and more! Others are smaller
                and simpler, keeping the focus on spending time together rather than extra park amenities. There's sure to be a spot that's right for
                you.
                <br />
                <br />
                We recommend reading reviews and reaching out to the host with any questions you have. Many of our dog beaches are open from sunrise
                to sunset, but each listing will confirm their hours when you go to book your reservation.
            </>
        ),
    },
    {
        que: 'What are the requirements to bring my dog to a Sniffspot beach?',
        ans: () => (
            <>
                We require that all dogs have basic vaccinations or equivalent titers. It's a good idea to keep your pet's vaccination records up to
                date. We do not permit private dog park use by pregnant dogs or pets with a bite history — and we require that pet parent guests sign
                our waiver and agree to follow our safety rules before bringing their furry friend to a Sniffspot dog park, such as staying within the
                designated off-leash area and only disposing of your pup's poop in designated waste receptacles. Additionally, we recommend following
                our water safety guidelines.
                <br />
                <br />
                Each park location also has their own set of rules that guests need to follow, such as limiting excessive barking and otherwise
                ensuring respectful canine behavior.
            </>
        ),
    },
    {
        que: 'Will there be other dogs at the Sniffspot beach at the same time as me?',
        ans: () => (
            <>
                No, there will not. Your rental is private, not a public county park! You will have your reserved Sniffspot all to yourself: a safe
                environment just for you and your furry friend to enjoy.
                <br />
                <br />
                Sniffspot only allows one booking at a time. Any host dogs are required to be kept away from the spot during visits. We also enforce
                30 minute time buffers between bookings to make sure you don't run into any surprises.
            </>
        ),
    },
    {
        que: 'How much do Sniffspot dog beaches cost?',
        ans: () => (
            <>
                Each host sets their own price, so you can check the price on the specific Sniffspot beach listing. Most are between $5 - $15 per dog
                per hour.
            </>
        ),
    },
    {
        que: 'Can I have an event or party at a Sniffspot dog beach?',
        ans: () => (
            <>
                If you are planning an amazing dog beach party, each Sniffspot beach has their own rules regarding special events. Many beaches allow
                doggie birthday parties, training sessions, and other events.
                <br />
                <br />
                Event organizers need to be responsible for their guests and should coordinate with the host ahead of time regarding their party.
            </>
        ),
    },
];

const INDOOR_FAQS_CONTENT = [
    {
        que: 'Are indoor dog parks safe?',
        ans: () => (
            <>
                While indoor off-leash dog parks are great for keeping your dog from running off and for providing enrichment when the weather isn't
                favorable, public dog parks — especially small enclosed ones — also have their drawbacks.
                <br />
                <br />
                Most indoor parks are small in size due to the financial and labor costs of setting up large buildings. There might not be enough
                space for dogs to interact naturally since indoor areas can cause some dogs to feel trapped in situations they aren't comfortable
                with. It's possible for nervous pups to be physically cornered in a busy dog park with no way to escape an interaction they don't
                want, which can lead to a “fight” response when “flight” isn't an option. Reading dog body language can be hard for many pet parents,
                which increases the risk of something going wrong if pups don't have superb social skills.
                <br />
                <br />
                Thankfully, these conventional dog park concerns don't apply to private listings since you and your dog will be the only ones there!
                Sniffspot dog parks are much safer than public city dog parks. Human and animal safety is our #1 focus. With Sniffspot all bookings
                are private for just you and dogs you bring with you and we require all dogs to be vaccinated (or have equivalent titers). All
                Sniffspot locations are vetted and reviewed by guests so you can find the perfect place for you and your dog. 93% of reviews on
                Sniffspot visits are 5 stars.
                <br />
                <br />
                And with indoor dog parks, you can get the safety of an enclosed indoor space for dogs — some even with soft rubber foam floors to
                reduce impact on your pup's joints — while still having plenty of square feet for fun.
            </>
        ),
    },
    {
        que: 'What are the benefits of indoor dog parks?',
        ans: () => (
            <>
                Two top pros of indoor dog parks: These enclosed off-leash areas keep your pet from running away, and they're great for getting
                exercise in poor weather.
                <br />
                <br />
                Recall training is tough work for any pet — and some breeds of dog have a genetic predisposition to roam. It isn't safe for your pup
                to run off into the wilderness (or throughout the neighborhood) unattended… but we all know that off-leash time can be great
                enrichment and allow for natural behaviors like sniffing. That's an important part of your dog's daily care. The solution? Secure
                areas! Indoor dog parks are one way to provide your dog with an opportunity to stretch their legs without causing you any worry that
                they'll escape or get in harm's way like they might at outdoor parks. Smaller square feet makes it easier to catch them when it's time
                to go home.
                <br />
                <br />
                Indoor parks are also a great option for pet parents who live in an area that's prone to inclement weather or experiences dramatic
                seasons, like harsh winters or unbearably humid summers. These off-leash spots are climate-controlled environments regardless of
                what's happening outside — making it possible to fulfill and tire your pup out in a safe way even on the days you'd rather stay cozied
                up out of the wind, sun, rain, or snow! That's something outdoor dog parks can't offer.
            </>
        ),
    },
    {
        que: 'How do I know if an indoor dog park works for my dog?',
        ans: () => (
            <>
                Many pet parents looking for indoor dog park options have dogs that are not good with voice control yet. We understand! You can filter
                Sniffspot dog parks by things like size to make sure you have enough square feet to play; amenities to check features you want for
                your activity like provided toys, agility or playground equipment, drinking water, fountains, self-wash stations, and additional
                services; as well as nearby distractions. If your dog is reactive to other dogs, the privacy of an indoor space will work well for
                you. Some indoor listings also have outdoor play spaces attached, too, for the best of both worlds.
                <br />
                <br />
                You can also browse on a map by park location to find a fun park in or near your city to make travel convenient.
                <br />
                <br />
                We recommend reading reviews and reaching out to the host ahead of time with any questions!
            </>
        ),
    },
    {
        que: 'Will there be other dogs at the Sniffspot indoor dog park at the same time as me?',
        ans: () => (
            <>
                No, there will not. Your rental is private, <i>not</i> a public dog park! You will have your reserved Sniffspot all to yourself: a
                safe environment just for you and your furry friend to enjoy.
                <br />
                <br />
                Sniffspot only allows one booking at a time. Any host dogs are required to be kept away from the spot during visits. We also enforce
                30 minute time buffers between bookings to make sure you don't run into any surprises.
            </>
        ),
    },
    {
        que: 'How can I find an indoor park for dogs near me?',
        ans: () => (
            <>You can browse all of our indoor parks up above to find the perfect comfortable environment to visit with your four-legged friend.</>
        ),
    },
    {
        que: 'What are the requirements to bring my dog to a Sniffspot indoor facility?',
        ans: () => (
            <>
                We require that all dogs have basic vaccinations or equivalent titers. It's a good idea to keep your pet's vaccination records up to
                date. We do not permit private dog park use by pregnant dogs or pets with a bite history — and we require that pet parent guests sign
                our waiver and agree to follow our safety rules before bringing their furry friend to a Sniffspot dog park, such as staying within the
                designated indoor area.
                <br />
                <br />
                Each park location also has their own set of rules that guests need to follow, such as limiting excessive barking and otherwise
                ensuring respectful canine behavior.
            </>
        ),
    },
    {
        que: 'How much do Sniffspot indoor dog parks cost?',
        ans: () => (
            <>
                Each indoor dog park location sets their own price, so you can check the price on the specific Sniffspot park location listing. Most
                are between $5 - $15 per dog per hour. Some hosts offer monthly membership options and other discounts for their dog parks. Others
                allow pet parents to host special events and might charge extra for parties.
            </>
        ),
    },
];

const POOL_FAQS_CONTENT = [
    {
        que: 'Are private dog swimming pools safe?',
        ans: () => (
            <>
                While public dog pools can have issues with crowding and cleanliness, Sniffspot's private dog swimming pools are much safer. With
                Sniffspot, all bookings are private for just you and the dogs you bring with you, and we require all dogs to be up-to-date on required
                vaccinations. All Sniffspot locations are vetted and reviewed by guests so you can find the perfect pool for you and your dog. An
                impressive 93% of reviews on Sniffspot visits are 5 stars.
                <br />
                <br />
                For dog swimming pool safety specifically, we recommend: knowing water safety guidelines, always supervising dogs during swim time,
                learning canine CPR, ensuring you know signs of fatigue, and considering a doggie life jacket for first-time swimmers. You can learn
                more about{' '}
                <a href={RouteFormatter.helpCenter.waterSafe()} target="_blank" rel="noreferrer">
                    dog swimming safety here.
                </a>
            </>
        ),
    },
    {
        que: 'What are the benefits of a private swimming pool for my dog?',
        ans: () => (
            <>
                Private dog swimming pools offer a controlled environment for exercise and enrichment. Unlike traditional dog parks that can become
                too hot in the summer months, swimming pools provide a refreshing way for dogs to stay active while keeping cool. Plus, all our pool
                locations are secured to keep your dog safe during their swim session. Swimming is also an excellent low-impact exercise, especially
                beneficial for senior dogs or those recovering from injury.
            </>
        ),
    },
    {
        que: 'Do all dogs know how to swim?',
        ans: () => (
            <>
                Not every dog is naturally comfortable in the water. Many first-time swimmers must learn how to paddle effectively and stay calm in
                deeper water. We recommend starting slowly in shallow areas and using a doggie life jacket if needed. Many Sniffspot hosts can provide
                guidance for first-time swimmers, and some even offer basic swimming instruction as an add-on service.
            </>
        ),
    },
    {
        que: 'How can I find private dog swimming pools near me? ',
        ans: () => (
            <>
                You can browse all of our dog swimming pools at the top of this page. Filter by location, amenities, and pool features to find the
                perfect spot for your pup's swimming pool session.
            </>
        ),
    },
    {
        que: 'What should I look for in a private dog swimming pool?',
        ans: () => (
            <>
                Consider factors like pool depth, temperature (some locations offer heated pools), entry/exit points, and available amenities like
                towels or drying stations. If your dog is new to swimming, look for pools with gradual entry or steps. You can also filter for fully
                fenced properties and check reviews from other guests. We recommend reaching out to hosts with specific questions about their pool
                setup.
            </>
        ),
    },
    {
        que: 'What are the requirements to bring my dog to a Sniffspot swimming pool?',
        ans: () => (
            <>
                We require that all dogs have basic vaccinations or equivalent titers. We do not permit dogs with a bite history or pregnant dogs.
                Guests must agree to follow our safety rules. Each host may have additional pool-specific guidelines, such as rinsing dogs before
                entering the pool.
            </>
        ),
    },
    {
        que: 'Will there be other dogs at the pool during my visit?',
        ans: () => (
            <>
                No. Your dog swimming pool booking is completely private. Sniffspot only allows one booking at a time, and any host dogs are kept away
                during visits. We enforce 30-minute time buffers between bookings to ensure privacy.
            </>
        ),
    },
    {
        que: 'How much do private dog swimming pools cost?',
        ans: () => (
            <>
                Each host sets their own price, typically ranging from $5-$25 per dog per hour depending on amenities. Heated pools or locations with
                additional features may have different pricing. Check individual listings for exact rates.
            </>
        ),
    },
];

export const SUB_TYPE_PARK_FAQS = {
    WATER: WATER_FAQS_CONTENT,
    HIKING: HIKING_FAQS_CONTENT,
    FENCED: FENCED_FAQS_CONTENT,
    FIELDS: FIELDS_FAQS_CONTENT,
    AGILITY: AGILITY_FAQS_CONTENT,
    SMALL: SMALL_FAQS_CONTENT,
    BEACH: BEACH_FAQS_CONTENT,
    INDOOR: INDOOR_FAQS_CONTENT,
    POOL: POOL_FAQS_CONTENT,
};
